import { QueryTags } from '@store/services/tags';
import { ResponseCodes } from '@store/services/types';
import { startLoading, stopLoading } from '@store/slices/uiSlice';

export const successTags = (tags: QueryTags[]) => (_: any, err: unknown) =>
  err ? [] : tags;

/** Tags refetched to pull the canvas back in sync with the model it is showing. */
const RESYNC_TAGS = [QueryTags.ProjectNodes, QueryTags.AssetNodes];

export const isProjectScopeMismatch = (err: any): boolean =>
  err?.data?.code === ResponseCodes.PROJECT_SCOPE_MISMATCH;

/**
 * Like {@link successTags}, but a PROJECT_SCOPE_MISMATCH rejection refetches the
 * model instead of invalidating nothing.
 *
 * That 409 means the canvas was showing one project while holding another
 * project's node ids. The server wrote nothing, so there is no result to apply —
 * but leaving the stale ids on screen means the user's next click repeats the
 * same bad request. Refetching replaces them with the ids that actually belong
 * to the model on screen.
 */
export const successTagsOrResync =
  (tags: QueryTags[]) => (_: any, err: unknown) => {
    if (isProjectScopeMismatch(err)) return RESYNC_TAGS;
    return err ? [] : tags;
  };

export const onLoading = (
  // eslint-disable-next-line default-param-last
  { noSpinner }: any = {},
  { dispatch, queryFulfilled, requestId }: any,
) => {
  if (noSpinner) return;

  dispatch(startLoading(requestId));
  return queryFulfilled.finally(() => dispatch(stopLoading(requestId)));
};
